import coreAPI from 'apis/core';

export const getMarketingPacks = async () => {
  const response = await coreAPI.marketing.getPacks();

  return response.data;
};

export const requestMarketingPack = async (pharmacyId, packName) => {
  await coreAPI.marketing.requestPack({ pharmacy_id: pharmacyId, pack_name: packName });
};

export const getMarketingResources = async (filters) => {
  const response = await coreAPI.marketing.getResources(filters);
  return response.data;
};

export const getMarketingResource = async (pharmacyId, resourceId, download = false) => {
  const response = await coreAPI.marketing.getResource(pharmacyId, resourceId, download);
  return response.data;
};

export const sendMarketingResourceEvent = async (pharmacyId, screen, action, name) => {
  const response = await coreAPI.marketing.sendMarketingEvent(pharmacyId, screen, action, name);
  return response.data;
};

export default {};
